import './SortingComponent.scss';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const SortingComponent = ({ sortBy, sortOrder, type, handleSorting }) => {
  return (
    <div className="tf-sort-cntr">
      <div
        className="tf-sort-icons"
        onClick={() => {
          console.log('clicked and type is ', sortOrder);
          if (sortBy === '' || sortBy !== type) {
            handleSorting(type, 'asc');
          } else {
            if (sortOrder === 'asc') {
              handleSorting(type, 'desc');
            } else {
              handleSorting(type, 'asc');
            }
          }
        }}
      >
        <span
          className={clsx('tf-sort-arrow-up', {
            active: type === sortBy && sortOrder === 'asc',
          })}
        ></span>
        <span
          className={clsx('tf-sort-arrow-down', {
            active: type === sortBy && sortOrder === 'desc',
          })}
        ></span>
      </div>
    </div>
  );
};

SortingComponent.propTypes = {
  sortBy: PropTypes.string,
  sortOrder: PropTypes.string,
  type: PropTypes.string,
  handleSorting: PropTypes.func,
};

export default SortingComponent;
